export const CHATBOT_FONT_FAMILIES: string[] = [
  'Open Sans',
  'Roboto',
  'Inter',
  'Lato',
  'Montserrat',
  'Poppins',
  'Noto Sans',
  'Oswald',
  'Raleway',
  'Nunito',
  'Rubik',
  'Work Sans',
  'Ubuntu',
  'PT Sans',
  'Roboto Condensed',
  'Playfair Display',
  'Merriweather',
  'Sofia Sans Extra Condensed'
];

export const CHATBOT_FONT_PREVIEW_STYLESHEET_URL = `https://fonts.googleapis.com/css2?${CHATBOT_FONT_FAMILIES.map(
  (family) => `family=${family.replace(/ /g, '+')}`
).join('&')}&display=swap`;
